// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartContentFooter_root__kSriN","content":"TripCartContentFooter_content__tA_s_"};